<template>
  <div class="login-container">
    <SquareGrid v-if="isLoading"
background="#10B3C7" />
    <div v-else
class="login-card">
      <div class="login-logo">
        <v-icon name="qbeek-login"
width="100"
height="100"
stroke="none" />
      </div>
      <div class="welcome-box">
        <div class="title">{{ $t("login.welcome") }}!</div>
        <div class="subtitle">
          {{ $t("login.pleaseSignIn") }}
        </div>
      </div>
      <form class="reg-form"
@submit.prevent="fnLogin">
        <div class="reg-form__inputs">
          <div :class="['reg-form__email']">
            <div class="reg-form__caption">Ваша почта</div>
            <ErrorCheck :is-error="v$?.email?.$error"
:error-message="v$?.email?.$errors[0]?.$message">
              <div class="wrapper-input">
                <input v-model="login_form.email"
:class="[
                  'reg-form__input',
                  { 'input-error': v$.password.$error },
                ]"
name="email"
placeholder="Введите вашу почту"
type="email"
autocomplete="username"
                  @focus="v$.$reset()">
                <v-icon v-if="isCloseVisible"
class="icon-remove"
name="x1"
width="20"
height="20"
stroke="#0E0E22"
                  @click="resetField" />
              </div>
            </ErrorCheck>
          </div>
          <div :class="['reg-form__password']">
            <div class="reg-form__caption">Пароль</div>
            <ErrorCheck :is-error="v$?.password?.$error"
:error-message="v$?.password?.$errors[0]?.$message">
              <div class="wrapper-input">
                <input v-model="login_form.password"
:class="[
                  'reg-form__input',
                  { 'input-error': v$.password.$error },
                ]"
name="password"
placeholder="Введите пароль"
:type="type"
autocomplete="current-password"
                  @focus="v$.$reset()">
                <v-icon v-if="isEyeIconVisible"
class="icon-pass-visibility"
:name="eyeIconName"
width="24"
height="24"
                  @click="toogleVisibility" />
              </div>
            </ErrorCheck>
          </div>
        </div>
        <div class="reg-form__settings">
          <checkbox-input v-model="login_form.isRememberMe"
:title="$t('login.rememberMe')" />
          <div class="reg-form__forgot-password"
@click="open">
            {{ $t("login.forgotPassword") }}
          </div>
        </div>
        <action-button action
type="submit"
:disabled="!checkFields"
w100p
class="login-btn">
          {{ $t("login.buttonLogin") }}
        </action-button>
      </form>

    </div>

  </div>
</template>

<script setup>
import { useStore } from "vuex";
import { ref, computed, reactive } from "vue";
import { useVuelidate } from "@vuelidate/core";
import { required, email, helpers } from "@vuelidate/validators";
import i18n from "@/i18n";
import CheckboxInput from "@/components/UI/inputs/CheckboxInput.vue";
import ForgotPassword from "@/components/UI/modals/ForgotPassword.vue";
import { useModal } from "vue-final-modal";
import { useToast } from "vue-toastification";
const toast = useToast();
const { open, close } = useModal({
  component: ForgotPassword,
  attrs: {
    onConfirm() {
      close();
    },
  },
});

const store = useStore();
const eyeIconName = ref("eye-opened");

const isLoading = computed(() => store.getters.getIsLoading);

const login_form = reactive({
  email: "",
  password: "",
  isRememberMe: false,
});

const errorLoginMessage = computed(() =>
  i18n.global.t(store.getters.errorLogin || "_")
);
const errorPasswordMessage = computed(() =>
  i18n.global.t(store.getters.errorPassword || "_")
);

const emailNotEmpty = computed(() =>
  i18n.global.t("login.errors.emailNotEmpty")
);
const emailNotValid = computed(() =>
  i18n.global.t("login.errors.emailNotValid")
);
const passwordNotEmpty = computed(() =>
  i18n.global.t("login.errors.passwordNotEmpty")
);

const isFirebaseLoginError = () => {
  return store.getters.errorLogin == null;
};

const isFirebasePasswordError = () => {
  return store.getters.errorPassword == null;
};

const rules = computed(() => {
  return {
    email: {
      required: helpers.withMessage(emailNotEmpty, required),
      email: helpers.withMessage(emailNotValid, email),
      isFirebaseLoginError: helpers.withMessage("", isFirebaseLoginError),
    },
    password: {
      required: helpers.withMessage(passwordNotEmpty, required),
      isFirebasePasswordError: helpers.withMessage(
        errorLoginMessage,
        isFirebaseLoginError
      ),
    },
  };
});
const v$ = useVuelidate(rules, login_form);
const type = ref("password");

const fnLogin = async () => {
  v$.value.$reset();
  store.commit("SET_ERROR_LOGIN", null);
  store.commit("SET_ERROR_PASSWORD", null);
  try {
    const resultValidate = await v$.value.$validate();
    if (resultValidate) {
      store.dispatch("login", login_form);
    } else {
      console.log("error validate", resultValidate);
    }
  } catch (error) {
    console.log('error', error);
    toast.error("Ошибка валидации");
  }
};

const checkFields = computed(
  () => login_form.email.length > 3 && login_form.password.length > 3
);
function resetField() {
  login_form.email = "";
}
const isCloseVisible = computed(
  () => login_form.email,
  () => login_form.email > 3
);
const isEyeIconVisible = computed(
  () => login_form.password,
  () => login_form.password > 3
);
function toogleVisibility() {
  type.value = type.value === "password" ? "text" : "password";
  eyeIconName.value =
    eyeIconName.value === "eye-opened" ? "eye-closed" : "eye-opened";
}
</script>
<style lang="scss" scoped>
.loginButton {
  background: #10b3c7 !important;
  color: white !important;

  &:hover {
    opacity: 0.8;
  }

  &:active {
    -webkit-box-shadow: inset 0 0 30px #0c8b9c;
    -moz-box-shadow: inset 0 0 30px #0c8b9c;
    box-shadow: inset 0 0 30px #0c8b9c;
  }
}

.login-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.login-card {
  display: flex;
  flex-direction: column;
  gap: 32px;
  align-items: center;
  padding: 40px;
  background: #fff;
  border-radius: 6px;
  min-width: 460px;
}

.login-card__wrpapper {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.language-box {
  width: 450px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 24px;
  color: #9b9b9b;
  text-decoration: none;
}

.login-logo {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
}

.welcome-box {
  width: 100%;

  .title {
    color: var(--Text, #595a5b);
    text-align: center;
    font-family: Montserrat, sans-serif;
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
    line-height: 110%;
    margin-bottom: 8px;
  }

  .subtitle {
    color: var(--main-colors-text, #595a5b);
    text-align: center;
    font-family: Inter, sans-serif;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 130%;
  }
}

.reg-form {
  display: flex;
  flex-direction: column;
  gap: 32px;
  align-items: center;
  width: 100%;

  &__inputs {
    display: flex;
    flex-direction: column;
    gap: 20px;
    width: 100%;
  }

  &__caption {
    font: normal 600 16px/20px Montserrat, sans-serif;
    color: #595a5b;
  }

  &__input {
    height: 40px;
    padding: 0px 38px 0 16px;
    align-items: center;
    gap: 8px;
    align-self: stretch;
    border-radius: 8px;
    border: 1px solid #e7e7e9;
    background: #fff;
    width: 100%;
    outline: none;

    &:not(:placeholder-shown) {
      border: 1px solid #a0a0a0;
      outline: 1px solid #a0a0a0;
    }
  }

  &__password-error {
    color: #f73a53;
  }

  &__btn {
    display: flex;
    padding: 12px 16px;
    justify-content: center;
    align-items: center;
    gap: 8px;
    align-self: stretch;
    border-radius: 8px;
    background: #eeeff2;

    cursor: pointer;

    border: none;
    font: normal 500 14px/130% Inter, sans-serif;
    color: #bcbbbb;
    width: 100%;
  }
}

.reg-form__settings {
  display: flex;
  justify-content: space-between;
  font: normal 400 14px/130% Inter, sans-serif;
  color: #595a5b;
  width: 100%;

  .reg-form__forgot-password {
    text-decoration: none;
    font-weight: 400;
    font-size: 14px;
    line-height: 130%;
    text-align: right;
    color: #595a5b;
    cursor: pointer;

    &:hover {
      color: #00cdd7;
    }
  }
}

.icon-remove {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
}

.icon-pass-visibility {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
}

.wrapper-input {
  position: relative;
}

.reg-form {

  &__password,
  &__email {
    display: flex;
    flex-direction: column;
    gap: 4px;
    width: 100%;
    flex: 1;
    font: normal 400 14px/130% Inter, sans-serif;
    color: #0e0e22;
  }
}

a:hover,
a:visited,
a:link,
a:active {
  text-decoration: none;
  color: #9b9b9b;
}

.language-box {
  font-weight: 400;
  font-size: 14px;
  line-height: 21px;
  display: flex;
  align-items: center;
  text-align: center;

  margin-top: 24px;
}

input:-webkit-autofill,
input:-webkit-autofill:focus {
  transition: background-color 600000s 0s, color 600000s 0s;
}

.error {
  font-size: 12px;
  line-height: 130%;

  color: #f73a53;
}

.input-error {
  border: 1px solid #f73a53 !important;
  outline: none !important;
  color: #f73a53 !important;

  svg {
    stroke: #f73a53 !important;
  }
}

.login-btn {
  height: 42px;
}
</style>
